import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { SOSurveyActionsVM, saveSOSurveyHandler } from './SOSurveyActionsVM';
import stores from 'cd-eft/models/Stores';
import './SOSurveyActions.scss';

const setStore = stores.AppStore.surveyEngineeringStore;

interface ISOSurveyActionsProps {
  add?: any;
  deleteStation?: any;
  save?: any;
  cancel?: any;
}

const SOSurveyActionsComponent = (props: ISOSurveyActionsProps) => {
  const vm = useRef(new SOSurveyActionsVM(props)).current;

  const { add, deleteStation, save, cancel } = props;
  const designStore = stores.AppStore.designStore;

  return (
    <>
      {(setStore.stationOffsetObject.offsetStations && setStore.stationOffsetObject.offsetStations.length > 1) ||
      (setStore.stationOffsetObject.crossSlopeStations &&
        setStore.stationOffsetObject.crossSlopeStations.length > 1) ? (
        <fieldset disabled={!designStore.hasProject()}>
          <div className="form-row-fixed-height justify-content-end my-2">
            <input
              className="usa-checkbox__input"
              type="checkbox"
              id="displaySurface"
              data-testid="displaySurface"
              checked={setStore.displaySurfaceChecked}
              onChange={() => (setStore.displaySurfaceChecked = !setStore.displaySurfaceChecked)}
            />
            <label className="usa-checkbox__label" htmlFor="displaySurface">
              Generate Surface
            </label>
          </div>
        </fieldset>
      ) : null}

      <div className="flex-justify form-row-fixed-height mb-0 mt-4">
        {/* <fieldset disabled={!designStore.hasProject()}> */}
        <div>
          {setStore.currentSubTab === 'survey' && (
            <>
              {add ? (
                <button className="usa-button" onClick={add}>
                  Add
                </button>
              ) : null}
              {deleteStation ? (
                <button className="usa-button usa-button--outline" onClick={deleteStation}>
                  Delete
                </button>
              ) : null}
            </>
          )}
        </div>
        <div>
          <button className="usa-button" onClick={vm.displaySurveyHandler}>
            Refresh Survey
          </button>
          <button className="usa-button usa-button--outline" onClick={cancel ? cancel : vm.cancelEditHandler}>
            Close
          </button>
          <button className="usa-button px-5 mr-0" onClick={save ? save : saveSOSurveyHandler}>
            Save
          </button>
        </div>
        {/* </fieldset> */}
      </div>
    </>
  );
};

export const SOSurveyActions = observer(SOSurveyActionsComponent);
